import gql from 'graphql-tag';

export const PARTNER_PROFILE_PROPOSAL_METRICS = gql`
  query PartnerProfileProposalMetrics($input: PartnerProductProposalMetricsInput!) {
    partnerProfileProductProposalMetrics(input: $input) {
      aftermarketProductId
      productName
      productCategory
      accountName
      acceptedCost
      soldRetailPrice
      acceptedRetailPrice
      avgMarkupFixedAccepted
      avgMarkupPercAccepted
      totalSent
      totalAccepted
      totalSold
      totalMarkupSold
      sentToAccepted
    }
  }
`;
